<div class="container-contact-us">
  <div class="container-icon"><img ngSrc="assets/images/icons/orange/question-square.svg" alt="Icon question square" height="32" width="32"></div>
  <div class="title">{{title}}</div>
  <div class="content mb-4">{{content}}</div>
  <img ngSrc="assets/images/icons/double-alt-arrow-down.svg" alt="Icon double alt arrow" height="32" width="32" class="animate-bounce mb-4">
  <button mat-flat-button routerLink="/public/nous-contacter"
          color="accent"
          type="submit">
    Nous contacter
  </button>
</div>
